module.exports = __webpack_public_path__ + "static/media/Away.d5c18b3e.jpeg";